// extracted by mini-css-extract-plugin
export default {"root":"Sales_root__TmD79","textContainer":"Sales_textContainer__ER9M8","titleText":"Sales_titleText__a4cpA","text":"Sales_text__ItBKc","banner":"Sales_banner__UXvb4"};